import { ArrowLeft } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";

export default function BackButton({ 
  to, 
  fallback = "/dashboard", 
  className = "",
  showOnHome = false 
}) {
  const navigate = useNavigate();
  const location = useLocation();

  // Don't show on home page unless specified
  if (!showOnHome && location.pathname === "/dashboard") {
    return null;
  }

  const handleBack = () => {
    if (to) {
      // Navigate to specific route
      navigate(to);
    } else if (window.history.length > 2) {
      // Go back if history exists
      navigate(-1);
    } else {
      // Fallback route
      navigate(fallback);
    }
  };

  return (
    <button
      onClick={handleBack}
      className={`inline-flex items-center gap-2 rounded-lg px-4 py-2 text-sm font-medium text-gray-700 transition-colors ${className}`}
    >
      <ArrowLeft className="h-4 w-4" />
      <span>Back</span>
    </button>
  );
}